import React, { Component } from 'react';
import { Collapse } from 'reactstrap';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { initCurrentBlog } from '../../../redux/actions/blogsActions';
import SidebarLink from './SidebarLink';
import { fetchDrafts } from '../../../redux/actions/draftsActions';
import { fetchPosts } from '../../../redux/actions/postsActions';
import { withTranslation } from 'react-i18next';

class BlogsList extends Component {
    static propTypes = {
        icon: PropTypes.string,
        isNew: PropTypes.bool,
        t: PropTypes.func.isRequired
    };

    static defaultProps = {
        icon: '',
        isNew: false,
    };

    constructor() {
        super();
        this.state = {
            collapse: false,
        };
    }

    toggle = () => {
        this.setState(prevState => ({ collapse: !prevState.collapse }));
    };

    selectBlog = (blog) => {
        console.log('blog selected:', blog._id);
        this.props.onSelectBlog(blog);
        this.toggle();
    }

    render() {
        const {
            icon, isNew, t
        } = this.props;
        const { collapse } = this.state;
        const categoryClass = classNames({
            'sidebar__category-wrap': true,
            'sidebar__category-wrap--open': collapse,
        });

        return (
            <div className={categoryClass}>
                <button type="button" className="sidebar__link sidebar__category" onClick={this.toggle} >
                    {icon ? <span className={`sidebar__link-icon lnr lnr-${icon}`} /> : ''}
                    <p className="sidebar__link-title">{this.props.blogs.blog && this.props.blogs.blog.title ? this.props.blogs.blog.title : t('menu.select_blog')}
                        {isNew && <span className="sidebar__category-new" />}
                    </p>
                    <span className="sidebar__category-icon lnr lnr-chevron-right" />
                </button>
                <Collapse isOpen={collapse} className="sidebar__submenu-wrap">
                    <ul className="sidebar__submenu">
                        <div>
                            {
                                this.props.blogs.blogs.map(blog => {
                                    return (
                                        <button key={blog._id} type="button" className="sidebar__link" onClick={() => this.selectBlog(blog)}>
                                            <p className="sidebar__link-title">{blog.title}</p>
                                        </button>
                                    )
                                })
                            }
                        </div>
                    </ul>
                    <ul className="sidebar__submenu">
                        <SidebarLink title={t('menu.create_blog')} route="/create" onClick={this.toggle} />
                    </ul>
                </Collapse>
            </div>
        );
    }
}


const mapDispatchToProps = dispatch => {
    return {
        onSelectBlog: (blog) => {
            dispatch(initCurrentBlog(blog._id));
            dispatch(fetchDrafts(blog._id));
            dispatch(fetchPosts(blog._id));
        }
    }
}

const mapStateToProps = (state) => {
    return {
        blogs: state.blogs
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('dashboard')(BlogsList));
